<template>
  <div class="ProjectOrderTable">
    <div class="section-title">基础信息</div>
    <table class="table">
      <tr>
        <td class="tableLabel">系统编号：</td>
        <td>{{repairRegistrationVo.billNo}}</td>
        <td class="tableLabel">产品条码：</td>
        <td>{{repairRegistrationVo.barcode}}</td>
        <td class="tableLabel">接收日期：</td>
        <td>{{repairRegistrationVo.receiveTime}}</td>
      </tr>
      <tr>
        <td class="tableLabel">接收人：</td>
        <td>{{repairRegistrationVo.receiveName}}</td>
        <td class="tableLabel">物料代码：</td>
        <td>{{repairRegistrationVo.materialNo}}</td>
        <td class="tableLabel">物料名称：</td>
        <td>{{repairRegistrationVo.materialName}}</td>
      </tr>
      <tr>
        <td class="tableLabel">物料型号：</td>
        <td>{{repairRegistrationVo.specification}}</td>
        <td class="tableLabel">批次数量：</td>
        <td>{{repairRegistrationVo.batchQuantity}}</td>
        <td class="tableLabel">职工姓名：</td>
        <td>{{repairRegistrationVo.nodeCode}}</td>
      </tr>
      <tr>
        <td class="tableLabel">工序名称：</td>
        <td>{{repairRegistrationVo.processName}}</td>
        <td class="tableLabel">异常项目：</td>
        <td>{{repairRegistrationVo.faultReporting}}</td>
        <td class="tableLabel">异常内容：</td>
        <td>{{repairRegistrationVo.exceptionNote}}</td>
      </tr>
      <tr>
        <td class="tableLabel">报修时间：</td>
        <td>{{repairRegistrationVo.faultTime}}</td>
        <td class="tableLabel">实测故障：</td>
        <td>{{repairRegistrationVo.faultActual}}</td>
        <td class="tableLabel">原因分析：</td>
        <td>{{repairRegistrationVo.reasonAnalise}}</td>
      </tr>
      <tr>
        <td class="tableLabel">维修人员：</td>
        <td>{{repairRegistrationVo.repairName}}</td>
        <td class="tableLabel">维修时间：</td>
        <td>{{repairRegistrationVo.repairTime}}</td>
        <td class="tableLabel">维修状态：</td>
        <td>{{repairRegistrationVo.statusName}}</td>
      </tr>
      <tr>
        <td class="tableLabel">备注：</td>
        <td>{{repairRegistrationVo.note}}</td>
        <td class="tableLabel">是否老化：</td>
        <td>{{repairRegistrationVo.isBurnIn ? '是' : '否'}}</td>
        <td class="tableLabel"/>
        <td/>
      </tr>
    </table>
    
    <div class="section-title">维修明细</div>
    <el-table
        :data="repairRegistrationVo.details"
        border>
      <el-table-column prop="shapeCode" width="160" align="center" label="条形码"/>
      <el-table-column prop="materialNo" width="160" align="center" label="物料号"/>
      <el-table-column prop="specifications" width="160" align="center" label="物料型号"/>
      <el-table-column prop="materialName" width="160" align="center" label="物料描述"/>
      <el-table-column prop="repairResult" width="160" align="center" label="故障描述"/>
      <el-table-column prop="afterSpecifications" width="160" align="center" label="更换器件"/>
      <el-table-column prop="maintenanceRecord" width="160" align="center" label="维修记录"/>
      <el-table-column prop="problemType" width="160" align="center" label="问题分类"/>
      <el-table-column prop="snowboardSupplier" width="160" align="center" label="单板供应商"/>
      <el-table-column prop="positionNo" width="160" align="center" label="器件位号"/>
    </el-table>
    
    <div class="section-title">附件信息</div>
    <el-table
        v-if="repairRegistrationVo.attachments && repairRegistrationVo.attachments.length > 0"
        :data="repairRegistrationVo.attachments">
      <el-table-column type="index" align="center" label="行号" width="60"/>
      <el-table-column prop="fileName" align="center" label="图片">
        <template slot-scope="scope">
          <el-image
              style="width: 50px; height: 50px;margin-right: 10px"
              :src="scope.row.imgUrl"
              :preview-src-list="imgUrls"/>
        </template>
      </el-table-column>
      <el-table-column prop="fileName" align="center" label="附件描述"/>
    </el-table>
    <div v-else style="text-align: center; color: #999; padding: 20px;">
      暂无附件
    </div>
  </div>
</template>

<script>
  export default {
    name: "RepairRegistrationSCPreview",
    data() {
      return {
        repairRegistrationVo: {
          details: [],
          attachments: [],
        },
        imgUrls: [],
      };
    },
    created() {
      this.getData();
    },
    methods: {
      getData() {
        const billId = this.$route.query.billId;
        this.$http.get("basic", `repairRegistrations/${billId}`).then((resp) => {
          if (resp.success) {
            this.repairRegistrationVo = resp.data;
            if (this.repairRegistrationVo.details.length>0) {
              this.repairRegistrationVo.details.forEach((item) => {
                if (item.problemType) {
                  item.problemType = item.problemType.split("/");
                }
              });
            }
            // 处理附件URL
            this.repairRegistrationVo.attachments.forEach(row => {
              this.$http.get("basic", `files/getDownloadUrl?key=${row.filePath}`).then((res) => {
                if (res.success) {
                  row.imgUrl = res.data;
                  this.imgUrls.push(row.imgUrl);
                }
              });

            });
          }
        });
      },
      downLoad(url, name) {
        const link = document.createElement("a");
        link.href = url;
        link.download = name;
        link.click();
      },
    },
  };
</script>

<style scoped>
  .ProjectOrderTable {
    padding: 20px;
  }
  
  .section-title {
    font-size: 16px;
    font-weight: bold;
    margin: 20px 0 10px 0;
    padding-bottom: 5px;
    border-bottom: 1px solid #dfe6ec;
  }
  
  .table {
    width: 100%;
    border-collapse: collapse;
    margin-bottom: 20px;
  }
  
  .table tr {
    border-bottom: 1px solid #dfe6ec;
  }
  
  .table td {
    padding: 12px;
    border: 1px solid #dfe6ec;
    vertical-align: top;
  }
  
  .tableLabel {
    background-color: #f5f7fa;
    color: #606266;
    font-weight: bold;
    width: 120px;
    text-align: right;
  }
</style>